import { motion } from "framer-motion";
import { Phone, MapPin, Clock, Instagram } from "lucide-react";

export default function ContactSection() {
  return (
    <section
      id="iletisim"
      data-testid="contact-section"
      className="py-24 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16 md:mb-20"
        >
          <p className="text-xs font-semibold uppercase tracking-[0.25em] gold-text mb-4">
            İletişim
          </p>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-black">
            Bize Ulaşın
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="space-y-8"
          >
            <div className="flex items-start gap-5" data-testid="contact-phone">
              <div className="w-12 h-12 flex items-center justify-center gold-bg flex-shrink-0">
                <Phone size={18} className="text-white" />
              </div>
              <div>
                <h3 className="text-base font-bold text-black mb-1">Telefon</h3>
                <a
                  href="tel:+905441199544"
                  className="text-sm text-black/60 hover:text-[#A66C6C] transition-colors duration-300"
                >
                  0544 119 95 44
                </a>
              </div>
            </div>

            <div className="flex items-start gap-5" data-testid="contact-location">
              <div className="w-12 h-12 flex items-center justify-center gold-bg flex-shrink-0">
                <MapPin size={18} className="text-white" />
              </div>
              <div>
                <h3 className="text-base font-bold text-black mb-1">Konum</h3>
                <p className="text-sm text-black/60">Bursa, Türkiye</p>
              </div>
            </div>

            <div className="flex items-start gap-5" data-testid="contact-hours">
              <div className="w-12 h-12 flex items-center justify-center gold-bg flex-shrink-0">
                <Clock size={18} className="text-white" />
              </div>
              <div>
                <h3 className="text-base font-bold text-black mb-1">Çalışma Saatleri</h3>
                <p className="text-sm text-black/60">Pazartesi - Cumartesi: 09:00 - 20:00</p>
              </div>
            </div>

            <div className="flex items-start gap-5" data-testid="contact-instagram">
              <div className="w-12 h-12 flex items-center justify-center gold-bg flex-shrink-0">
                <Instagram size={18} className="text-white" />
              </div>
              <div>
                <h3 className="text-base font-bold text-black mb-1">Instagram</h3>
                <a
                  href="https://instagram.com/pureviaguzellikbursa"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-black/60 hover:text-[#A66C6C] transition-colors duration-300"
                >
                  @pureviaguzellikbursa
                </a>
              </div>
            </div>

            {/* WhatsApp CTA */}
            <a
              href="https://wa.me/905441199544"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="contact-whatsapp-cta"
              className="inline-flex items-center justify-center bg-black text-white hover:bg-gray-900 transition-colors duration-300 px-8 py-4 uppercase tracking-widest text-sm font-semibold mt-4"
            >
              WhatsApp ile İletişime Geç
            </a>
          </motion.div>

          {/* Google Maps */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            data-testid="contact-map"
            className="w-full h-[400px] lg:h-full min-h-[400px] border border-[#EBEBEB]"
          >
            <iframe
              title="Purevia Güzellik Bursa Konum"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d97040.22261098993!2d28.94534!3d40.18275!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14ca3f9d0002dc73%3A0x4fc3bbd7c1ea9e4e!2sBursa%2C%20T%C3%BCrkiye!5e0!3m2!1str!2str!4v1700000000000!5m2!1str!2str"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
